// Source: Confluence page 589004806, version 6 (2026-09-08).
export const xlncaContentEN = {
  purpose: {
    title: "Purpose",
    description:
      "Organizations rely on processes to create value. Improving them requires testing new ways of working, coordinating participants, collecting information, and tracking results. But the work around a process or pilot can fragment across spreadsheets, documents, email, collaboration tools, signatures, and other disconnected systems.",
    highlight: "XLNC-A brings that work together.",
    summary:
      "XLNC-A turns business processes into configurable digital workflows that connect people, information, actions, permissions, and outputs in one place.",
  },
  overview: {
    title: "What is XLNC-A?",
    paragraphs: [
      "XLNC-A is a configurable platform for bringing work streams into a digital environment, adapting them to an organization's operational needs. Instead of building each solution from scratch, organizations configure Value Streams, Forms, Questions, permissions, users, branding, and Outputs within a flexible foundation. Each organization operates through its own Tenant Portal, set up for its processes, users, access rules, branding, and requirements.",
      "This configuration-driven approach lets XLNC-A support different processes and use cases while keeping a consistent digital experience.",
    ],
  },
  flow: {
    title: "From Process to Digital Flow",
    description:
      "At GBCI Group, Operational Excellence means finding opportunities to improve work and testing those improvements through pilots. XLNC-A provides the infrastructure to turn processes and pilots into connected workflows. Instead of moving information between disconnected tools, participants follow a structured flow where each step, Form, action, permission, and Output links together.",
    steps: ["Design", "Configure", "Execute", "Track", "Evaluate"],
  },
  work: {
    title: "Work Where the Process Happens",
    paragraphs: [
      "XLNC-A is available on both web and mobile, letting users interact with their workflows in the environment that fits their role. The web experience supports configuring and managing workflows, while XLNCA Mobile extends key capabilities beyond the desktop.",
      "From office administration to field work, users can access assigned processes, complete Forms, provide information, and keep work moving without being tied to one environment.",
    ],
  },
  waste: {
    title: "Designed to Reduce Waste",
    description:
      "XLNCA is built on a simple idea: support technology should not become another source of waste.",
    introduction:
      "By connecting information, people, Forms, permissions, actions, and Outputs within a configurable workflow, XLNC-A helps organizations:",
    benefits: [
      "Reduce manual steps.",
      "Minimize reliance on disconnected tools.",
      "Keep information centralized and tied to the process.",
      "Guide participants through the correct workflow.",
      "Improve visibility across execution.",
      "Standardize process execution.",
      "Adapt digital workflows as business needs change.",
      "Run pilots with greater consistency.",
    ],
  },
  adapt: {
    title: "Built to Adapt",
    description:
      "XLNC-A's configurable architecture lets organizations create digital experiences around their processes rather than forcing processes into a fixed application. Value Streams, Forms, Questions, permissions, navigation, Outputs, branding, and access models can be configured to meet operational requirements.",
  },
  tryIt: {
    title: "Try XLNCA",
    description:
      "See how a configurable digital workflow can simplify how your organization executes processes and pilots.",
    closing: "Reduce waste. Connect the process. Move work forward with XLNCA.",
    contact: "Contact Us",
  },
};
